/** Build-time config for the browser kiosk shell. */

export const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? '0.1.0';

export function getApiBaseUrl(): string {
  const configured = import.meta.env.VITE_API_BASE_URL?.trim();
  if (configured) return configured.replace(/\/$/, '');
  if (import.meta.env.DEV) return 'http://localhost:3000';
  throw new Error('VITE_API_BASE_URL is required for production builds');
}
